import React, { useState } from 'react';
import { backdropProps } from '../utils/backdropClose';
import { supabase } from '../supabase';

// Edit lookup list (rename / description). EDIT-ONLY — admins can't create lists (a list is inert
// until a developer wires a field to it); lists are dev-provisioned/seeded.
// Props: isDark; list (the row being edited); onClose; onSuccess(row).
export default function AddListModal({ isDark, list, onClose, onSuccess }) {
  const [form, setForm] = useState({ name: list?.name || '', description: list?.description || '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const c = isDark
    ? { card: '#2F3854', border: '#374060', text: '#e8eaf2', muted: 'var(--slate)', input: 'var(--ink)', inputBorder: '#434C68' }
    : { card: '#ffffff', border: 'var(--line)', text: 'var(--ink)', muted: 'var(--slate)', input: '#ffffff', inputBorder: '#c8ccd8' };
  const s = {
    label:    { display: 'block', fontSize: '11px', fontWeight: '700', color: c.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' },
    input:    { width: '100%', padding: '8px 11px', background: c.input, border: `1px solid ${c.inputBorder}`, borderRadius: '7px', color: c.text, fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: "'Public Sans',system-ui,sans-serif" },
    textarea: { width: '100%', padding: '8px 11px', background: c.input, border: `1px solid ${c.inputBorder}`, borderRadius: '7px', color: c.text, fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: "'Public Sans',system-ui,sans-serif", minHeight: '58px', resize: 'vertical' },
    btn:      { padding: '9px 18px', background: 'linear-gradient(135deg,#B40000,#9C0000)', border: 'none', borderRadius: '7px', color: 'white', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: "'Public Sans',system-ui,sans-serif" },
    btnGhost: { padding: '9px 16px', background: 'transparent', border: `1px solid ${c.border}`, borderRadius: '7px', color: c.muted, fontSize: '13px', cursor: 'pointer', fontFamily: "'Public Sans',system-ui,sans-serif" },
  };

  const set = (f, v) => setForm(prev => ({ ...prev, [f]: v }));
  const txt = v => (v && v.trim() ? v.trim() : null);

  async function handleSave() {
    if (!form.name.trim()) { setError('Name is required.'); return; }
    setSaving(true); setError('');
    try {
      const fields = { name: form.name.trim(), description: txt(form.description) };
      const { data, error: e } = await supabase.from('lookup_lists').update(fields).eq('id', list.id).select().single();
      if (e) throw e;
      onSuccess(data);
    } catch (e) {
      setError(e?.code === '23505' ? 'A list with that name already exists.' : (e?.message || 'Save failed.'));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div {...backdropProps(onClose)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: c.card, borderRadius: '14px', padding: '28px', maxWidth: '480px', width: '100%', boxShadow: '0 8px 40px rgba(0,0,0,0.3)', fontFamily: "'Public Sans',system-ui,sans-serif" }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
          <div style={{ fontFamily: "'Archivo',sans-serif", fontSize: '20px', fontWeight: '700', color: c.text }}>Edit List</div>
          <button onClick={onClose} type="button" style={{ background: 'none', border: 'none', color: c.muted, fontSize: '18px', cursor: 'pointer', padding: '0 4px', lineHeight: 1 }}>✕</button>
        </div>
        <div style={{ marginBottom: '14px' }}><label style={s.label}>Name *</label><input style={s.input} value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Services" /></div>
        <div style={{ marginBottom: '14px' }}><label style={s.label}>Description</label><textarea style={s.textarea} value={form.description} onChange={e => set('description', e.target.value)} /></div>
        {error && <div style={{ color: '#f87171', fontSize: '12px', marginBottom: '10px' }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button type="button" onClick={onClose} disabled={saving} style={s.btnGhost}>Cancel</button>
          <button type="button" onClick={handleSave} disabled={saving} style={s.btn}>{saving ? 'Saving…' : 'Save Changes'}</button>
        </div>
      </div>
    </div>
  );
}
